import React, { useCallback, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { l, BtnV2 } from '@manychat/manyui'

import IgPreviewModal, {
  IgPreviewModalProps,
} from 'common/builder/components/manager/flow/IgPreviewModal/IgPreviewModal'
import { handleCatch } from 'shared/api/lib/errors/handlers'
import { manychatApi } from 'shared/api/requests/manychat'

export const InstagramPreviewButton = () => {
  const [query] = useSearchParams()
  const shareHash = query.get('share_hash') ?? ''

  const [isLoading, setIsLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const [previewInfo, setPreviewInfo] = useState<
    Pick<IgPreviewModalProps, 'previewUsername' | 'keyword'>
  >({
    previewUsername: '',
    keyword: '',
  })

  const fetchInstagramPreviewInfo = useCallback(async () => {
    try {
      setIsLoading(true)

      const {
        data: { channels },
      } = await manychatApi.getPreviewState({
        query: {
          share_hash: shareHash,
        },
      })

      setPreviewInfo({
        keyword: channels?.instagram?.preview_keyword ?? '',
        previewUsername: channels?.instagram?.username ?? '',
      })
      setIsModalOpen(true)
    } catch (error) {
      handleCatch(error)
    } finally {
      setIsLoading(false)
    }
  }, [shareHash])

  const closeModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  return (
    <>
      <IgPreviewModal
        isShareFlowPage
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        {...previewInfo}
      />

      <BtnV2
        onClick={fetchInstagramPreviewInfo}
        loading={isLoading}
        size="large"
        leftIcon="InstagramChannel"
      >
        <span>{l.translate('Preview')}</span>
      </BtnV2>
    </>
  )
}
